import { Injectable, inject } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ConfigService } from './config.service';
import { firstValueFrom } from 'rxjs';
import { VirtualRoles } from '../models/virtualRoles.model';
import { Config } from '../models/config.model';

@Injectable({
  providedIn: 'root',
})
export class EnvironmentLoaderService {
  private configService = inject(ConfigService);

  private appConfig: Config;

  constructor() {
    this.appConfig = new Config();
  }

  get config(): Config {
    return this.appConfig;
  }

  get virtualRoles(): VirtualRoles {
    return this.appConfig.virtualRoles;
  }

  async load(): Promise<any> {
    this.appConfig = environment;
    this.appConfig.virtualRoles = await firstValueFrom(this.configService.config$);
    return Promise.resolve();
  }
}
